import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { catchError, throwError } from 'rxjs';

export const errorToastInterceptor: HttpInterceptorFn = (req, next) => {
  const toastr = inject(ToastrService);
  return next(req).pipe(
    catchError((error) => {
      const status = error?.status ?? 0;

      if (status === 401 || status === 403) {
        const errBody = error?.error;
        const candidate =
          (typeof errBody?.error === 'object' && errBody?.error?.message) ||
          errBody?.error?.message ||
          errBody?.message;
        if (typeof candidate === 'string' && candidate.trim().length > 0) {
          toastr.error(candidate);
        } else if (status === 403) {
          toastr.error('You do not have permission to perform this action.');
        }
        return throwError(() => error);
      }

      let message = 'An error occurred. Please try again later.';
      const errBody = error?.error;
      const candidate =
        (typeof errBody?.error === 'object' && errBody?.error?.message) ||
        errBody?.error?.message ||
        errBody?.message;
      if (typeof candidate === 'string' && candidate.trim().length > 0) {
        message = candidate;
      } else if (status >= 500) {
        message = 'An unexpected error occurred. Please contact support.';
      }

      toastr.error(message);
      return throwError(() => error);
    })
  );
};
